"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sprite = exports.SpriteSyncType = exports.SpriteAlphaType = exports.SpriteType = void 0;
const Reader_1 = require("../Reader");
const Util_1 = require("./Util");
var SpriteType;
(function (SpriteType) {
    SpriteType[SpriteType["VP_PARALLEL_UPRIGHT"] = 0] = "VP_PARALLEL_UPRIGHT";
    SpriteType[SpriteType["FACING_UPRIGHT"] = 1] = "FACING_UPRIGHT";
    SpriteType[SpriteType["VP_PARALLEL"] = 2] = "VP_PARALLEL";
    SpriteType[SpriteType["ORIENTED"] = 3] = "ORIENTED";
    SpriteType[SpriteType["VP_PARALLEL_ORIENTED"] = 4] = "VP_PARALLEL_ORIENTED";
})(SpriteType || (exports.SpriteType = SpriteType = {}));
var SpriteAlphaType;
(function (SpriteAlphaType) {
    SpriteAlphaType[SpriteAlphaType["SPR_NORMAL"] = 0] = "SPR_NORMAL";
    SpriteAlphaType[SpriteAlphaType["SPR_ADDITIVE"] = 1] = "SPR_ADDITIVE";
    SpriteAlphaType[SpriteAlphaType["SPR_INDEXALPHA"] = 2] = "SPR_INDEXALPHA";
    SpriteAlphaType[SpriteAlphaType["SPR_ALPHTEST"] = 3] = "SPR_ALPHTEST";
})(SpriteAlphaType || (exports.SpriteAlphaType = SpriteAlphaType = {}));
var SpriteSyncType;
(function (SpriteSyncType) {
    SpriteSyncType[SpriteSyncType["SYNCHRONIZED"] = 0] = "SYNCHRONIZED";
    SpriteSyncType[SpriteSyncType["RANDOM"] = 1] = "RANDOM";
})(SpriteSyncType || (exports.SpriteSyncType = SpriteSyncType = {}));
class Sprite {
    constructor(header, frames) {
        this.header = header;
        this.frames = frames;
    }
    static parse(buffer) {
        const r = new Reader_1.Reader(buffer);
        const magic = r.nstr(4);
        if (magic !== 'IDSP') {
            throw new Error('Invalid sprite file format');
        }
        const header = {
            version: r.i(),
            type: r.i(),
            alphaType: r.i(),
            radius: r.f(),
            width: r.i(),
            height: r.i(),
            frameCount: r.i(),
            beamLength: r.f(),
            syncType: r.i()
        };
        const paletteSize = r.s();
        const palette = r.arrx(paletteSize * 3, Reader_1.ReaderDataType.UByte);
        const frames = [];
        for (let i = 0; i < header.frameCount; ++i) {
            const frame = {
                group: r.i(),
                position: [r.i(), r.i()],
                width: r.i(),
                height: r.i(),
                data: new Uint8Array(header.width * header.height * 4)
            };
            const pixels = r.arrx(header.width * header.height, Reader_1.ReaderDataType.UByte);
            if (header.alphaType === SpriteAlphaType.SPR_ALPHTEST) {
                frame.data = (0, Util_1.paletteWithLastTransToRGBA)(pixels, palette);
            }
            else {
                frame.data = (0, Util_1.paletteToRGBA)(pixels, palette);
            }
            frames.push(frame);
        }
        return new Sprite(header, frames);
    }
}
exports.Sprite = Sprite;
